/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { CONFIRM_AND_ASSIGN, CONFIRM_AND_ASSIGN_RESPONSE,RESET_CONFIRM_AND_ASSIGN_RESPONSE } = constants.ConfirmAndAssignConstants;


export default {
    CONFIRM_AND_ASSIGN,
    CONFIRM_AND_ASSIGN_RESPONSE,
    RESET_CONFIRM_AND_ASSIGN_RESPONSE,

  confirmAndAssign: payload => ({
    type: CONFIRM_AND_ASSIGN,
    payload
  }),
  confirmAndAssignReceived: () => ({
    type: CONFIRM_AND_ASSIGN_RESPONSE
  }),
  resetConfirmAndAssign: () => ({
    type: RESET_CONFIRM_AND_ASSIGN_RESPONSE
  }),
};
